import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { SummaryFileTemplate } from "~/models/SummaryFileTemplate";

const paths = {
	index: "/summary_file_templates"
} as const;

type TIndex = () => SwrReturnType<SummaryFileTemplate[]>;
type ReturnType = {
	useIndex: TIndex;
};

export const useSummaryFileTemplates = (): ReturnType => {
	const useIndex: TIndex = () => {
		const { data, mutate, error } = useSWR<SummaryFileTemplate[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	return { useIndex };
};
